import {useObserver} from "~image";
export const EMPTY_GIF = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const defineMixin = (opts) => opts;
export const lazyMixin = defineMixin({
  data() {
    return {
      lazyLoad: this.loading === "lazy"
    };
  },
  mounted() {
    if (this.lazyLoad) {
      this.observe();
    }
  },
  beforeDestroy() {
    this.unobserve();
  },
  methods: {
    observe() {
      ;
      this._removeObserver = useObserver(this.$el, () => {
        this.lazyLoad = false;
      });
    },
    unobserve() {
      const {_removeObserver} = this;
      if (_removeObserver) {
        _removeObserver();
        delete this._removeObserver;
      }
    }
  }
});
